/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_VerifyingInputs */



/**
* | output |
* | --- |
* | "Verifying link..." |
*
* @param {Auth_Verify_VerifyingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_verifying = /** @type {((inputs?: Auth_Verify_VerifyingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_VerifyingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérification du lien...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Verificando enlace...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Verificando link...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica del link...")
	return /** @type {LocalizedString} */ ("Verifying link...")
});